import React, { Fragment } from "react"
import { Currencies, Rules } from "@orbital/games-frontend-library"

import { GAME_RULES_PROPS } from "./interface"
import { MENU_SETTINGS, GAMEPLAY, SET_STAKE_OPTIONS } from "./CONTENT"

import CustomRules from "./customRules/CustomRules"
import GameDescription from "./customRules/GameDescription"


const MAX_WIN = 1000;

export default function GameRulesChildren({
  colors,
  gameInfo,
}: GAME_RULES_PROPS) {
  const { game_settings, currency,
      minBet,
      maxBet,
  } = gameInfo
  return (
    <Fragment>
         <GameDescription />
        <p>
            The max win is {`${currency} ${maxBet * MAX_WIN}`} of your
            bet <br/>
            Minimum Bet: {`${currency} ${minBet}`} <br />
            Maximum Bet: {`${currency} ${maxBet}`}
        </p>

        <h3>settings:</h3>
        <Rules content={MENU_SETTINGS} colors={colors} />
        <h3>Gameplay customization:</h3>
        <Rules content={GAMEPLAY} colors={colors} />
        <h5>Options:</h5>
        <Rules content={SET_STAKE_OPTIONS} colors={colors} />
        <h3>Winning Combinations:</h3>
        *Max Win Amount for Videopoker Gamble round is{" "}
        {game_settings && game_settings.maxWin}
        {Currencies[currency]} win above this won't be added to your balance
        although you can play the game to try and win more for fun although only
        win amount you will be awarded will not exceed max win amount.
        <CustomRules colors={colors} coefs={game_settings.coefs} />
    </Fragment>
  )
}
